import { memo } from 'react';
import '../../components/Templates/Referral/SmartParentsProgramTemplate/SmartParentsProgramTemplate.css';
import { SvgIcon } from '../../components/Molecules';
import { SVGIconType } from '../../constants/svgIcon';
import { useTranslation } from 'react-i18next';
import { getSmartParentsImage } from '../../constants/images';

export const ReferralGuaranteedDetails = memo(() => {
  const { t, i18n } = useTranslation(); //{t('')}
  const arrow = (
    <svg
      className="arrow"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"
        fill="#666"
      />
    </svg>
  );
  return (
    <div className="smart-parents-program">
      <div className="centered-container-nobg">
        <div className="container-blue2">
          <SvgIcon
            name={SVGIconType.Gurantee}
            className={'title-icon'}
            stroke={'#ffffff'}
          />
          <p className="text-white-l">{t('100% English Results Guaranteed')}</p>
          <p className="text-white-m">
            {t(
              "We believe in helping you succeed! If you don't see the improvement you're hoping for after 6 months with us, we will provide a full refund.",
            )}
          </p>
        </div>
        <div className="container-white">
          <img
            src={getSmartParentsImage('img13', i18n.language)}
            className="img13Result"
            alt="JOYAJOY Banner"
          />
          <p className="text-black-m">
            {t('Here are the key terms of our refund policy:')}
          </p>
          <div className="policy-list">
            <details className="policy-item">
              <summary className="text-green-m">
                {t('1. Refund eligibility')}
                {arrow}
              </summary>
              <p className="policy-content">
                {t(
                  'To qualify for a refund, participants must use the JOYAJOY app for at least 2 hours per month during their first 6 months of the program. Refunds are only eligible for first-year users of the program.',
                )}
              </p>
            </details>
            <details className="policy-item">
              <summary className="text-green-m">
                {t('2. Refund request submission')}
                {arrow}
              </summary>
              <p className="policy-content">
                {t(
                  'Refund request must be submitted within the first 7 days of the 7th month, after completing 6 months of continuous usage as specified in term 1 above.',
                )}
              </p>
            </details>
            <details className="policy-item">
              <summary className="text-green-m">
                {t(
                  '3. Not Eligible for Refund if Referral Reward exceeded admission cost',
                )}
                {arrow}
              </summary>
              <p className="policy-content">
                {t(
                  'Refund would not be eligible if participant has earned referral rewards exceeding their program admission fee.',
                )}
              </p>
            </details>
            <details className="policy-item">
              <summary className="text-green-m">
                {t('4. Dispute Resolution')}
                {arrow}
              </summary>
              <p className="policy-content">
                {t(
                  'In the event of any disputes arising from or related to this refund policy or this program, JOYAJOY reserves the sole and final decision-making authority. All decisions made by JOYAJOY regarding such disputes shall be binding and conclusive.',
                )}
              </p>
            </details>
          </div>
        </div>
      </div>
    </div>
  );
});
